{
  "version": "0.2.10",
  "extensionId": "objhnmnodmnmjiegkddnfgbjbhfohokm",
  "sha256": "7cd5f03da09ed01e043dc364a29df88e33b92460625c2fa1ef632858fdc9250e",
  "bytes": 73110,
  "download": "https://gab.ai/browser-extension/gab-ai-browser-extension-preview.zip",
  "channel": "manual-preview",
  "chatOrigin": "https://gab.ai"
}
